import Api from '../api/api.js';


class AssessQuestions {


	init()
	{
		this.cacheDom();

		this.initDatepickers();

		this.initStepper();
	}


	cacheDom()
	{
		this.$assessment_date = $('#assessment-date');

		this.$stepper = $('.stepper');
	}


	initDatepickers()
	{
		this.initAssessmentDatepicker();
	}	


	initAssessmentDatepicker()
	{
		const input = this.$assessment_date.get(0);

		if (!input || typeof flatpickr === 'undefined') {
			return;
		}

		if (input.dataset.assessmentPickerInit === '1') {
			return;
		}

		input.dataset.assessmentPickerInit = '1';

		flatpickr(input, {
			dateFormat: 'Y-m-d',
			defaultDate: this.$assessment_date.data('value') || input.value || null,
			monthSelectorType: 'dropdown',
			shorthandCurrentMonth: false,
			allowInput: true
		});
	}


	initStepper()
	{
		this.$stepper.mdbStepper();
	}

}


class AssessTasks {


	init(assessment_id, user_id)
	{
		this.user_id = user_id;

		this.assessment_id = assessment_id
	
		this.cacheDom();

		this.initDatepickers();

		this.initStepper();
	}


	cacheDom()
	{
		this.$assessment_date = $('#assessment-date');

		this.$task_row = $('.student-task-row');

		this.$task_dates = this.$task_row.find('.datepicker');

		this.$stepper = $('.stepper');

		this.$task_progress = $('#task-progress');

		this.taskPickers = new Map();
	}


	findDate(task_id)
	{
		return $('.student-task-row').find('input[data-task=' + task_id + ']');
	}


	initDatepickers() 
	{
		this.initTaskDatepickers();

		this.initAssessmentDatepicker();
	}


	initTaskDatepickers()
	{
		var _this = this;

		this.$task_dates.each(function() {

			const $date = $(this);
			const input = $date.get(0);

			if (!input || typeof flatpickr === 'undefined' || input.dataset.taskPickerInit === '1') {
				return;
			}

			input.dataset.taskPickerInit = '1';

			const value = $date.data('value');

			var $row = $date.closest('.student-task-row');

    		const task_id = $row.data('task');

			const picker = flatpickr(input, {
				dateFormat: 'Y-m-d',
				defaultDate: value || input.value || null,
				monthSelectorType: 'dropdown',
				shorthandCurrentMonth: false,
				allowInput: true,
				onChange: function(selectedDates, dateStr) {
					if (selectedDates.length) {
						_this.completeTask(_this.user_id, task_id, dateStr);
					} else {
						_this.uncompleteTask(_this.user_id, task_id);
					}
				}
			});

			_this.taskPickers.set(String(task_id), picker);
		});
	}


	initAssessmentDatepicker()
	{
		const input = this.$assessment_date.get(0);

		if (!input || typeof flatpickr === 'undefined') {
			return;
		}

		if (input.dataset.assessmentPickerInit === '1') {
			return;
		}

		input.dataset.assessmentPickerInit = '1';

		flatpickr(input, {
			dateFormat: 'Y-m-d',
			defaultDate: this.$assessment_date.data('value') || input.value || null,
			monthSelectorType: 'dropdown',
			shorthandCurrentMonth: false,
			allowInput: true
		});
	}


	initStepper()
	{
		this.$stepper.mdbStepper();
	}


	isCompleted($date)
	{
		const input = $date.get(0);

		return !!(input && input.value);
	}


	refreshLineThrough(task_id)
	{
		const $date = this.findDate(task_id);

		const checked = this.isCompleted($date);

		const $label = $date.closest('.student-task-row').find('.checklist label');

		if (checked) {

			$label.addClass('checked');

		} else {

			$label.removeClass('checked');

		}
	}


	lastUpdated(task_id)
	{
		this.refreshLineThrough(task_id);

		this.refreshProgress();
	}


	refreshProgress()
	{
		(new Api).getRequest(`/admin/users/${this.user_id}/assessments/${this.assessment_id}/tasks/partials`, {}).then((response) => {

			this.$task_progress.html(response.progress);
		
		});
	}


	completeTask(user_id, task_id, completed)
	{ 
		const data = {completed};

		(new Api).postRequest(`/admin/users/${user_id}/tasks/${task_id}`, data).then(() => {

			this.lastUpdated(task_id);
		
		}, () => {
			
			this.lastUpdated(task_id);
		
		});
	}


	uncompleteTask(user_id, task_id)
	{
		(new Api).deleteRequest(`/admin/users/${user_id}/tasks/${task_id}`, {}).then(() => {

			this.lastUpdated(task_id);
		
		}, function() {
		
			this.lastUpdated(task_id);
		
		});
	}


	populateDate(task_id)
	{
		const key = String(task_id);
		const picker = this.taskPickers.get(key);

		if (picker) {
			picker.setDate(new Date(), true);
			return;
		}

		const input = $('input.datepicker[data-task=' + task_id + ']').get(0);
		if (input) {
			input.value = new Date().toISOString().slice(0, 10);
		}
	}


 	clearDate(task_id)
	{
		const key = String(task_id);
		const picker = this.taskPickers.get(key);

		if (picker) {
			picker.clear();
			return;
		}

		const input = $('input.datepicker[data-task=' + task_id + ']').get(0);
		if (input) {
			input.value = '';
		}
	}


}


export default class AssessUser {
	
	
	init(params = {})
	{
		switch (params.type) {

			case 'questions':
				(new AssessQuestions).init();
			break;

			case 'tasks':
				(new AssessTasks).init(params.assessment_id, params.user_id);
			break;

			default:
				throw new Error('Unknown assessment type');

		}
	}

}